import Appointment from "@/components/Appointment/Appointment";
import AppointmentSpecials from "@/components/AppointmentSpecials/AppointmentSpecials";
import InputEmail from "@/components/inputs/InputEmail/InputEmail";
import ParticipantAdministrative from "@/components/ParticipantAdministrative/ParticipantAdministrative";
import SectionTitle from "@/components/SectionTitle/SectionTitle";
import { AppointmentDTO } from "@/models/AppointmentDTO";
import { ActionTypes, GetterTypes } from "@/store-vuex/types";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import { ParticipantDTO } from "@/models/ParticipantDTO";
import { useEquestHome } from "@/config/app.config";
import InputTel from "@/components/inputs/InputTel/InputTel";
import InformationBlock from "../InformationBlock/InformationBlock";
import { McsisConstants } from "@/models/constants/McsisConstants";
import AppointmentService from "@/services/appointment.service";
import { ApplicationDefaultValue } from "@/models/constants/ApplicationDefaultValue";
import InputText from "../inputs/InputText/InputText.vue";
import { PublicAppointmentParticipantResponse } from "@/models/PublicAppointmentParticipantResponse";
import DoctorService from "@/services/doctor.service";
import { DoctorDTO } from "@/models/DoctorDTO";
import InsuranceService from "@/services/insurance.service";
import { InsuranceDTO } from "@/models/InsuranceDTO";
import EavService from "@/services/eav.services";
import { EavAttributeName, EavClassName, EavParent } from "@/models/constants/eav";

@Component({
  components: {
    Appointment,
    InputEmail,
    InputTel,
    ParticipantAdministrative,
    SectionTitle,
    AppointmentSpecials,
    InformationBlock,
    InputText
  }
})
export default class AppointmentRecap extends Vue {
  @Prop(Boolean) public readonly!: boolean;

  public isPhoneNumberMandatory = false;
  public isEmailAddressMandatory = false;
  public areEmailAndPhoneReadonly = false;
  public insuranceName: string = McsisConstants.EmptyString;
  public doctorFullName: string = McsisConstants.EmptyString;
  public noDoctorInList = true;
  private isEQuestUsedByCenter = false;
  private phoneRegex = new RegExp(McsisConstants.PhoneNumberRegex);
  private internationalPhoneRegex = new RegExp(
    McsisConstants.InternationalPhoneNumberRegex
  );
  private emailRegex = new RegExp(McsisConstants.EmailRegex);

  protected async mounted(): Promise<void> {
    await AppointmentService.IsPhoneNumberMandatory().then((res: any) => {
      this.isPhoneNumberMandatory = res;
    });
    await AppointmentService.IsEmailMandatory().then((res: any) => {
      this.isEmailAddressMandatory = res;
    });
    if(this.showAppointmentParticipantStep){
      if (this.appointment.appId !== undefined){
        await AppointmentService.getPublicAppointmentParticipant(this.suId, this.appointment.partId!, this.appointment.appId!).then(
          async (response: PublicAppointmentParticipantResponse | null) => {
            if (response !== null && response !== undefined) {
              if (response.avsNumber !== null && response.avsNumber !== undefined){
                this.participant.avsNumber = response.avsNumber;
              }
              if (response.insuranceId !== null && response.insuranceId !== undefined){
                await InsuranceService.fetchInsurances().then(
                  async (insurances: InsuranceDTO[]) => {
                    const insurance = insurances.find(x => x.personId === response.insuranceId)
                    this.insuranceName = insurance !== undefined ? insurance.insName : McsisConstants.EmptyString;
                  }
                )
              }
              // TODO INSURANCE NAME
              if (response.doctorId !== null && response.doctorId !== undefined){
                this.noDoctorInList = false;
                await DoctorService.getDoctor(response.doctorId).then(
                  async(doc: DoctorDTO | null) =>{
                    this.doctorFullName = doc !== null ? doc!.doctorName : McsisConstants.EmptyString;
                  }
                );
              } else {
                this.participant.doctorFirstname = response.doctorFirstName;
                this.participant.doctorLastname = response.doctorLastName;
                this.participant.doctorAddress = response.doctorAddress;
                this.participant.doctorLocality = response.doctorLocality;
                this.participant.doctorPhone = response.doctorPhoneNumber
              }
              if (response.email !== null && response.email !== undefined && response.email.trim().length > ApplicationDefaultValue.StringEmptyLength){
                this.appointment.appEmail = response.email;
              }
              if (response.mobilePhoneNumber !== null && response.mobilePhoneNumber !== undefined && response.mobilePhoneNumber.trim().length > ApplicationDefaultValue.StringEmptyLength){
                this.appointment.appMobile = response.mobilePhoneNumber;
              }
            }
          }
        )
      } else {
        if (this.participant !== null &&
          this.participant !== undefined &&
          this.participant.insurance !== null &&
          this.participant.insurance != undefined
        ) {
          this.insuranceName = this.participant.insurance.insName;
        }
    
        if (this.participant !== null &&
          this.participant !== undefined &&
          this.participant.doctor !== null &&
          this.participant.doctor != undefined
        ) {
          this.noDoctorInList = false;
          this.doctorFullName = this.participant.doctor.doctorName;
        }
    
        // Init e-mail and mobile phone number of the appointment with participant values (ParticipantAdministrative or values from step 1 for TG canton if set)
        if (this.participant !== null &&
          this.participant !== undefined &&
          this.participant.email !== null &&
          this.participant.email !== undefined &&
          this.participant.email.trim().length > ApplicationDefaultValue.StringEmptyLength
        ) {
          this.appointment.appEmail = this.participant.email;
          this.$store.commit(ActionTypes.setAppointment, this.appointment);
        }
    
        if (this.participant !== null &&
          this.participant !== undefined &&
          this.participant.phoneNumber !== null &&
          this.participant.phoneNumber !== undefined &&
          this.participant.phoneNumber.trim().length > ApplicationDefaultValue.StringEmptyLength
        ) {
          this.appointment.appMobile = this.participant.phoneNumber;
          this.$store.commit(ActionTypes.setAppointment, this.appointment);
        }
      }
    }
    if (this.appointment.center != null && this.appointment.center.personId != null)
    {
      await EavService.getBooleanEav(
        EavParent.EXAM_CENTER, 
        this.appointment.center.personId, 
        EavClassName.EXAM_CENTER_PARAM, 
        EavAttributeName.USE_EQUESTIONNAIRE
      ).then((res: boolean) => {
        this.isEQuestUsedByCenter = res;
      });
    }

    this.areEmailAndPhoneReadonly = this.showAppointmentParticipantStep ? true : this.readonly;

    this.checkValidity();
  }

  public get suId(): number {
    return this.$store.getters[GetterTypes.screeningUnit];
  }

  /**
   * Get the ParticipantDTO instance
   */
  public get participant(): ParticipantDTO {
    return this.$store.getters[GetterTypes.participant];
  }

  /**
   * Gets true if AppointmentParticipant step must be displayed
   *
   * @returns {boolean} true or false
   */
  public get showAppointmentParticipantStep(): boolean {
      return this.$store.getters[GetterTypes.showAppointmentParticipantStep];
  }

  /**
   * Check whether we have to display or not the E-Quest@Home link button
   */
  protected get showEquestLink(): boolean {
    return useEquestHome(this.$route.params.screening)
      && this.readonly
      && !this.showAppointmentParticipantStep
      && (this.isEQuestUsedByCenter);
  }

  private get appointment(): AppointmentDTO {
    return this.$store.getters[GetterTypes.appointment];
  }

  private setAppMobile(mobile: string | null) {
    this.$store.commit(ActionTypes.setAppMobile, mobile);
    this.checkValidity();
  }

  private setAppEmail(email: string | null) {
    this.$store.commit(ActionTypes.setAppEmail, email);
    this.checkValidity();
  }

  private checkValidity(): void {
    const emailValidity = this.checkEmailAddressValidity(
      this.appointment.appEmail,
      this.isEmailAddressMandatory
    );
    const mobileValidity = this.checkPhoneNumberValidity(
      this.appointment.appMobile,
      this.isPhoneNumberMandatory
    );
    const doctorValidity = this.checkDoctorValidity();
    this.$emit("validityChange", mobileValidity && emailValidity && doctorValidity);
  }

  /**
   * Check if doctor data is valid when showAppointmentParticipantStep is true
   * Either a doctor must be selected from the dropdown OR all manual doctor fields must be filled
   * @returns {boolean} valid or not valid
   */
  private checkDoctorValidity(): boolean {
    if (!this.showAppointmentParticipantStep) {
      return true;
    }

    // If doctor was selected from dropdown
    if (this.participant.doctor !== null && this.participant.doctor !== undefined) {
      return true;
    }

    // If manual doctor fields are filled (noDoctorInList checkbox was checked)
    // All fields must be filled: LastName, FirstName, Address, Locality, Phone
    const hasManualDoctorData =
      this.participant.doctorLastname !== null &&
      this.participant.doctorLastname !== undefined &&
      this.participant.doctorLastname.trim().length > 0 &&
      this.participant.doctorFirstname !== null &&
      this.participant.doctorFirstname !== undefined &&
      this.participant.doctorFirstname.trim().length > 0 &&
      this.participant.doctorAddress !== null &&
      this.participant.doctorAddress !== undefined &&
      this.participant.doctorAddress.trim().length > 0 &&
      this.participant.doctorLocality !== null &&
      this.participant.doctorLocality !== undefined &&
      this.participant.doctorLocality.trim().length > 0 &&
      this.participant.doctorPhone !== null &&
      this.participant.doctorPhone !== undefined &&
      this.participant.doctorPhone.trim().length > 0;

    return hasManualDoctorData;
  }

  /**
   * Check if email field is valid
   * If mandatory then it must be filled and must be an email address checked with regex
   * If not mandatory, must be an email address checked with regex if filled (can be empty)
   * @param {string | null} emailAddress email address to check
   * @param {bool} isMandatory mandatory or not
   * @returns {bool} valid or not valid
   */
  private checkEmailAddressValidity(
    emailAddress: string | null,
    isMandatory: boolean
  ): boolean {
    if (isMandatory) {
      return emailAddress != null && this.emailRegex.test(emailAddress);
    } else {
      return (
        emailAddress == null ||
        emailAddress === McsisConstants.EmptyString ||
        this.emailRegex.test(emailAddress)
      );
    }
  }

  /**
   * Check if phone number field is valid
   * If mandatory then it must be filled and must be an phone number checked with regexes
   * If not mandatory, must be an phone number checked with regexes if filled (can be empty)
   * @param {string | null} emailAddress email address to check
   * @param {bool} isMandatory mandatory or not
   * @returns {bool} valid or not valid
   */
  private checkPhoneNumberValidity(
    phoneNumber: string | null,
    isMandatory: boolean
  ): boolean {
    if (isMandatory) {
      return (
        phoneNumber != null &&
        (this.internationalPhoneRegex.test(phoneNumber) ||
          this.phoneRegex.test(phoneNumber))
      );
    } else {
      return (
        phoneNumber == null ||
        phoneNumber === McsisConstants.EmptyString ||
        this.internationalPhoneRegex.test(phoneNumber) ||
        this.phoneRegex.test(phoneNumber)
      );
    }
  }

  private get isModified(): boolean {
    return this.$store.getters[GetterTypes.isRdvModified];
  }

  private get isEdition(): boolean {
    return this.$store.getters[GetterTypes.hasRdv];
  }

  private get hasParticularity(): boolean {
    return (
      this.$store.getters[GetterTypes.useLongAppointment] ||
      this.$store.getters[GetterTypes.useTRMGenderChoice]
    );
  }

  private get equestRouteName(): string {
    const equest = process.env.VUE_APP_EQUEST_ROOT;
    const suName = this.$route.params.screening;
    const birthDate = moment(this.participant.birthDate).format(
      McsisConstants.SwissDateFormat
    );
    const partId = this.participant.partId;

    return `${equest}/${suName}/at-home/identification?partId=${partId}&birthDate=${birthDate}`;
  }

  private get titleKey(): string {
    if (this.isModified) {
      return "page.recap.modificationTitle";
    } else if (this.isEdition) {
      return "page.recap.editionTitle";
    } else {
      return "page.recap.insertTitle";
    }
  }
}
